import { h } from 'preact';

import pageStyles from '../../../pageStyles';

import { SadlibAd } from '../../../../pieces/sadlib-ad';
import { TopBar } from '../../../../pieces/topbar';

import { Column, Row, Section, ContainerFluid } from '@cube/layout';
import { MobileHeader } from '@cube/header-widget';
import { PressWidget } from '@cube/finance-components';

export const Tablet = ({ pageConfig, ...props }) =>
	(
		<div>
			<MobileHeader
				{...props}
				{...pageConfig.header}
			/>
			<TopBar
				type="finance"
			/>
			<ContainerFluid>
				<Section rowClass={pageStyles.desktopContentPadding} containerClass={pageStyles.defaultTabletPageWidth}>
					<Row>
						<Column>
							<PressWidget />
						</Column>
					</Row>
				</Section>
				<SadlibAd id="adhesion" />
			</ContainerFluid>
		</div>
	);
